import _ from 'lodash';

import chartModel from '../../models/chartModel';
import Filters from '../../constants/filters';

import RevenueDrawingService from '../../services/drawing/RevenueDrawingService';
import GrowthRateDrawingService from '../../services/drawing/GrowthRateDrawingService';
import NewDrugsDrawingService from '../../services/drawing/NewDrugsDrawingService';

export default {
    namespaced: true,
    state: {
        charts: [
            Object.assign({}, JSON.parse(JSON.stringify(chartModel)), {
                chartId: 1,
            }),
        ],
        currentIndex: 0,
        nextChartId: 2,
        refreshFilterFlag:true,
    },
    getters: {
        getLogActive(state){
            return state.logActive;
        },
        getCharts(state) {
            return state.charts;
        },
        getCurrentIndex(state) {
            return state.currentIndex;
        },
        getNextChartLoading(state) {
            return state.nextChartLoading;
        },
        getCurrentChart(state) {
            return state.charts[state.currentIndex];
        },
    },
    mutations: {
        selectChart(state, index) {
            Object.assign(state, {
                currentIndex: index,
            });
        },
        addChart(state) {
            const newChart = JSON.parse(JSON.stringify(chartModel));
            newChart.chartId = state.nextChartId;

            Object.assign(state, {
                charts: [
                    ...state.charts,
                    newChart,
                ],
                currentIndex: state.charts.length,
                nextChartId: state.nextChartId + 1,
            });
        },
        removeChart(state, index) {
            if (state.charts.length > 1) {
                const currentIndex = state.currentIndex === state.charts.length - 1
                    ? state.currentIndex - 1
                    : state.currentIndex;

                Object.assign(state, {
                    charts: state.charts.filter((chart, chartIndex) => chartIndex !== index),
                    currentIndex,
                });
            } else {
                const newChart = JSON.parse(JSON.stringify(chartModel));
                newChart.chartId = state.nextChartId;

                Object.assign(state, {
                    charts: [newChart],
                    currentIndex: 0,
                });
            }
        },
        setChart(state, newChart) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    ...newChart,
                } : chart)),
            });
        },
        setChartInit(state, { chartName, chartState }) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    name: chartName,
                    state: chartState,
                } : chart)),
            });
        },
        setChartData(state, chartData) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    data: chartData,
                } : chart)),
            });
        },        
        setChartCumulativeData(state, chartCumulativeData) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    cumulativeData: chartCumulativeData,
                } : chart)),
            });
        },
        setChartFicBicData(state, chartFicBicData) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    ficBicData: chartFicBicData,
                } : chart)),
            });
        },
        setChartName(state, chartData) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    name: chartData,
                } : chart)),
            });
        },
        setChartEvents(state, events) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    events,
                } : chart)),
            });
        },
        setChartLoading(state, loading) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    loading,
                } : chart)),
            });
        },
        toggleFilters(state, isOpen) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    filters: {
                        ...chart.filters,
                        open: typeof isOpen !== 'undefined' ? isOpen : !chart.filters.open,
                    },
                    viewDetails: {
                        ...chart.viewDetails,
                        open: false,
                    },
                    viewCompetitors: {
                        ...chart.viewCompetitors,
                        open: false,
                    },
                } : chart)),
            });
        },
        refreshFilterFlag(state) {
            Object.assign(state, {
                refreshFilterFlag:   !state.refreshFilterFlag,
            });
        },
        toggleLogActive(state, scaleLogType) {
            let chart = state.charts[state.currentIndex];
            chart.filters.scaleLogType =scaleLogType;
            if (chart.drawingService) {
                if (chart.filters.scaleLogType) {
                    chart.drawingService.changeToLogScale()
                } else {
                    chart.drawingService.changeToLinearScale()
                }
                chart.drawingService.refreshScale()
            }
        },
        toggleShowStopIcon(state, showStopIcon) {
            let chart = state.charts[state.currentIndex];
            chart.filters.showStopIcon =showStopIcon;
            if (chart.drawingService) {
                chart.drawingService.updateStoppedDotsVisibility(showStopIcon);
            }

        },
        toggleLegendSort(state, legendSort) {
            let chart = state.charts[state.currentIndex];
            chart.filters.legendSort =legendSort;
        },
        toggleShowLoe(state, showLoe) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => {
                    if (index === state.currentIndex) {
                            return {
                                ...chart,
                                filters: {
                                    ...chart.filters,
                                    showLoe: showLoe,
                                },
                            };
                    }  
                    return chart;
                })
            });

            const chart = state.charts[state.currentIndex];
            if(chart.drawingService){
                chart.drawingService.toggleShowLoe();
            }
        },
        toggleColorByFicBic(state, colorByFicBic) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => {
                    if (index === state.currentIndex) {
                            return {
                                ...chart,
                                filters: {
                                    ...chart.filters,
                                    colorByFicBic: colorByFicBic,
                                },
                            };
                    }  
                    return chart;
                })
            });

            const chart = state.charts[state.currentIndex];
            if(chart.drawingService){
                chart.drawingService.toggleColorByFicBic();
            }
        },
        setFilters(state, filters) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => {
                    if (index === state.currentIndex) {
                        const newFilters = {
                            ...chart.filters,
                            ...filters,
                        };

                        if((newFilters.startSyncView || newFilters.cumulativeType !== 'none') && newFilters.showLoe)
                            newFilters.showLoe = false;

                        if(newFilters.cumulativeType !== 'none' && newFilters.colorByFicBic)
                            newFilters.colorByFicBic = false;

                        return {
                            ...chart,
                            filters: newFilters,
                        };
                    }  
                    return chart;
                })
            });
        },
        toggleTabMenu(state, { chartIndex, open, top, left }) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === chartIndex ? {
                    ...chart,
                    tabMenu: {
                        open: typeof open !== 'undefined' ? open : !chart.tabMenu.open,
                        top,
                        left,
                    },
                } : chart)),
            });
        },
        toggleViewCompetitors(state, { drugId, drugName, isOpen }) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    viewCompetitors: {
                        open: typeof isOpen !== 'undefined' ? isOpen : !chart.viewCompetitors.open,
                        drugId: typeof drugId !== 'undefined' ? drugId : chart.viewCompetitors.drugId,
                        drugName: typeof drugName !== 'undefined' ? drugName : chart.viewCompetitors.drugName,
                    },
                    viewDetails: {
                        ...chart.viewDetails,
                        open: false,
                    },
                    filters: {
                        ...chart.filters,
                        open: false,
                    },
                } : chart)),
            });
        },
        toggleViewDetails(state, { data, drugName, companyName, isOpen }) {
            Object.assign(state, {
                charts: state.charts.map((chart, index) => (index === state.currentIndex ? {
                    ...chart,
                    viewDetails: {
                        open: typeof isOpen !== 'undefined' ? isOpen : !chart.viewDetails.open,
                        data: typeof data !== 'undefined' ? { ...data, brand_name: drugName, company_name: companyName } : chart.viewDetails.data,
                    },
                    filters: {
                        ...chart.filters,
                        open: false,
                    },
                    viewCompetitors: {
                        ...chart.viewCompetitors,
                        open: false,
                    },
                } : chart)),
            });
        },
        updateLineState(state, {lineId, lineState}) {
            let chart = state.charts[state.currentIndex];

            chart.filters.linesState[lineId] = lineState;
        },
    },
    actions: {
        async reloadChart(context){
            const chart = context.state.charts[context.state.currentIndex];
            await context.dispatch('applyFilters',{...chart});
        },
        async forceRedrawChart(context){
            const chart = context.state.charts[context.state.currentIndex];
            if(chart.drawingService){
                chart.drawingService.forceRedraw();
            }
        },
        async handleLoeEventsUpdate(context, { updatedLoeEvents, dataKey }){
            const chart = context.state.charts[context.state.currentIndex];

            const newChartEvents = { ...chart.events };

            newChartEvents[dataKey]['loe_dates'] = updatedLoeEvents.map((e) => { return { ...e, key: dataKey }; });

            context.commit("setChartEvents", newChartEvents);

            if(chart.drawingService){
                chart.drawingService.handleLoeEventsUpdated(newChartEvents);
            }
        },
        async drawGraph(context) {
            const chart = context.state.charts[context.state.currentIndex];
            const selector = `chart-drawing-${chart.chartId}`;

            if (chart.drawingService) {
                delete chart.x_domain_low;
                delete chart.x_domain_high;
                delete chart.y_domain_low;
                delete chart.y_domain_high;
                delete chart.drawingService;
            }

            if (chart.filters.chartType === 'revenue' || chart.filters.viewCompetitors) {
                chart.drawingService = await new RevenueDrawingService(selector, chart, 'revenue', chart.filters.cumulativeType);
            } else if (chart.filters.chartType === 'growth') {
                chart.drawingService = await new GrowthRateDrawingService(selector, chart, 'growth');
            } else if (chart.filters.chartType === 'new') {
                chart.drawingService = await new NewDrugsDrawingService(selector, chart, 'new', chart.filters.cumulativeType);
            }


            if (Object.keys(chart.drawingService.data).length > 0) {
                chart.drawingService.drawGraph();
            } else {
                chart.drawingService.clearDrawing();
            }

            /**
             * @info: This is used for assigning the tags type to "Growth Rate",
                but when the state is regenerated the type and structure are different which sets the svg chart to empty and generates an error
             * @Solution: The controll is made on TagsComp.. by controlling the "breakApart" value
             */
            // if (chart.filters.breakApart) {
            //     chart.filters.chartType = 'growth';
            // }
        },
        async applyFilters(context, { firstInit, chartName, filters } = {}) {
            const filtersData = JSON.parse(JSON.stringify(filters));
            const { chartType, cumulativeType, growthRates, growthRatesQuarters, range, revenueFilterRange, companies, categories, subcategories, classes, brands, excludeBrands, tags ,revenues, curves, quarterData, showStopIcon, scaleLogType, showCumulativeRevenueChart, startSyncView, legendSort, colorByFicBic} = filtersData;
            const filtersFilled = JSON.parse(JSON.stringify({   companies, categories, subcategories, classes, brands, tags }));

            const setBreakApartType = chartType === 'growth' && growthRates.length === 1;
            const chartReqFilters = {
                growthRates: chartModel.filters.growthRates,
                companies: chartModel.filters.companies,
                categories: chartModel.filters.categories,
                subcategories: chartModel.filters.subcategories,
                classes: chartModel.filters.classes,
                brands: chartModel.filters.brands,
                tags: chartModel.filters.tags
            };

            if (chartType !== 'growth') {
                filtersFilled.growthRates = growthRates;
            } else {
                filtersFilled.growthRates = [];
            }

            if (_.isEqual(filtersFilled, chartReqFilters) && chartType !== 'new') {
                let message = 'Please apply at least one filter to create a chart.';

                if (tags.length > 0) {
                    message = 'A sub-category or category or any other filters should be applied';
                }
                context.dispatch('message/show', {
                    type: 'error',
                    text: message,
                }, { root: true });
            } else {
                context.commit('setChartLoading', true);

                let chartData;
                let chartCumulativeData;
                let chartFicBicData;
                let chartEvents;

                if (setBreakApartType || chartType === 'growth') {

                    chartData = await context.dispatch('api/request', {
                        service: 'growthRate',
                        type: 'getAll',
                        data: { growthRates, growthRatesQuarters, companies, categories, subcategories, classes, brands, excludeBrands, tags, curves, quarterData  },
                    }, { root: true });

                } else if (!setBreakApartType && chartType === 'revenue') {

                    const response = await context.dispatch('api/request', {
                        service: 'drugRevenue',
                        type: 'getAll',
                        data: { companies, categories, subcategories, classes, brands, excludeBrands, quarterData, tags, revenues, curves, revenuefilter: revenueFilterRange, cumulativeType, showCumulativeRevenueChart: showCumulativeRevenueChart, startSyncView: startSyncView, getFicBicData: true },
                    }, { root: true });

                    if (response) {
                        chartData = response.revenues;
                        chartCumulativeData =  (response.cumulativeRevenueChart!==undefined)? response.cumulativeRevenueChart:null;
                        chartFicBicData =  (response.chartFicBicData!==undefined)? response.chartFicBicData:null;
                        chartEvents = response.events;
                    }
                } else if (chartType === 'new') {
                    const newRange = range=== null? 0:range;
                    const response = await context.dispatch('api/request', {
                        service: 'newDrugs',
                        type: 'getAll',
                        data: {
                            range: newRange,
                            companies,
                            categories,
                            subcategories,
                            classes,
                            brands,
                            excludeBrands,
                            quarterData,
                            tags,
                            revenues,
                            curves,
                            revenuefilter: revenueFilterRange,
                            cumulativeType,
                            showCumulativeRevenueChart: showCumulativeRevenueChart,
                            startSyncView: startSyncView,
                            getFicBicData: true,
                        },
                    }, { root: true });

                    if (response) {
                        chartData = response.revenues;
                        chartCumulativeData =  (response.cumulativeRevenueChart!==undefined)? response.cumulativeRevenueChart:null;
                        chartFicBicData =  (response.chartFicBicData!==undefined)? response.chartFicBicData:null;
                        chartEvents = response.events;
                    }
                }

                context.commit('setChartLoading', false);

                if (chartData || chartEvents) {

                    if (setBreakApartType) {
                        const rateData = chartData[Object.keys(chartData)[0]];
                        //const rateName = Filters.growthRates.find(growthRate => growthRate.value === Object.keys(chartData)[0]).text;

                        await context.dispatch('breakApart', {
                            parentChartType: chartType,
                            rateData,
                            // rateName,
                            firstInit,
                            filters,
                            chartName,
                            addNewChart: false
                        });
                        context.commit('toggleFilters', false);
                    } else {

                        context.commit('setChartCumulativeData', chartCumulativeData); 
                        context.commit('setChartData', chartData);
                        context.commit('setFilters', Object.assign({}, filtersData, {
                            open: false,
                            breakApart: false,
                            viewCompetitors: false,
                        }));
                        context.commit('setChartEvents', chartEvents);
                        context.commit('setChartFicBicData', chartFicBicData);
                        setTimeout(async () => {
                            if (firstInit) {
                                context.commit('setChartInit', { chartName, chartState: 'view' });
                            } else {
                                await context.dispatch('drawGraph');
                            }
                        }, 0);

                        // dispatch a refresh "event"
                         context.commit('refreshFilterFlag');

                    }
                }
            }
        },
        async viewCompetitors(context, { chartType, drugId, drugName, type, growthRates = [], growthRatesQuarters = [], range = null,revenues = null, curves = null,  startSyncView = false, showCumulativeRevenueChart = false, showLoe = false, colorByFicBic = false, categories = [], showStopIcon = false, legendSort = false, scaleLogType = false} = {}) {
            context.commit('setChartLoading', true);

            const isBreakApartType = chartType === 'growth' && growthRates.length === 1;

            const response = await context.dispatch('api/request', {
                service: 'viewCompetitors',
                type: 'get',
                data: { drugId, type, range, revenues, curves, categories, breakApart: isBreakApartType, startSyncView, showCumulativeRevenueChart, growthRates, growthRatesQuarters, getFicBicData: true},
            }, { root: true });

            context.commit('setChartLoading', false);

            if (response) {
                context.commit('addChart');
                context.commit('setChartData', response.revenues);
                context.commit('setChartFicBicData', response.chartFicBicData);
                context.commit('setChartCumulativeData', response.cumulativeRevenueChart); 
                context.commit('setChartEvents', response.events);
                context.commit('setFilters', {
                    classes: response.classes,
                    subcategories: response.subcategories,
                    categories: categories,
                    viewCompetitors: true,
                    chartType,
                    growthRates,
                    growthRatesQuarters,
                    range,
                    revenues,
                    curves,
                    startSyncView,
                    showCumulativeRevenueChart,
                    showLoe,
                    colorByFicBic,
                    showStopIcon,
                    legendSort,
                    scaleLogType,
                });

                setTimeout(() => {
                    const typeSingular = type === 'subcategories' ? 'sub-category' : 'class';
                    context.commit('setChartInit', {
                        chartName: `${drugName} competitors by ${typeSingular}`,
                        chartState: 'view',
                    });
                }, 0);
            }
        },
        async viewDetails(context, { drugId, drugName, companyName } = {}) {
            context.commit('setChartLoading', true);

            const drugDetails = await context.dispatch('api/request', {
                service: 'viewDetails',
                type: 'get',
                data: { drugId },
            }, { root: true });

            context.commit('setChartLoading', false);

            if (drugDetails) {
                context.commit('toggleViewDetails', { data: drugDetails, drugName, companyName, isOpen: true });
            }
        },
        openLoadChart(context) {
            const existingLoadChart = context.getters.getCharts.findIndex(chart => chart.state === 'load');

            if (existingLoadChart >= 0) {
                context.commit('selectChart', existingLoadChart);
            } else {
                context.commit('addChart');
                context.commit('setChartInit', { chartName: 'Load Chart', chartState: 'load' });
            }
        },
        async loadCharts(context) {
            return context.dispatch('api/request', {
                service: 'chart',
                type: 'getAll',
            }, { root: true });
        },
        async exportChartCsv(context) {
            const chart = context.state.charts[context.state.currentIndex];
            const filters = chart.filters;
            const name = chart.name;
            const filtersData = JSON.parse(JSON.stringify(filters));
            const { chartType, cumulativeType, growthRates, growthRatesQuarters, range, revenueFilterRange, companies, categories, subcategories, classes, brands, excludeBrands, quarterData, tags ,revenues, curves, showStopIcon, scaleLogType, legendSort,showCumulativeRevenueChart, startSyncView, showLoe, colorByFicBic} = filtersData;
            const newRange = range=== null? 0:range;
            const setBreakApartType = chartType === 'revenue' && growthRates.length === 1;

            if (setBreakApartType) {
                // const response = await context.dispatch('api/request', {
                //     service: 'breakApart',
                //     type: 'getAll',
                //     data: { rateData, companies: filters.companies,  growthRatesQuarters: filters.growthRatesQuarters ,name},
                // }, { root: true })
                // context.commit('setChartLoading', false);
            } else if (!setBreakApartType && chartType === 'revenue') {
                const response = await context.dispatch('api/request', {
                    service: 'drugRevenue',
                    type: 'exportChartCsv',
                    data: { companies, categories, subcategories, classes, brands, excludeBrands, quarterData, tags ,revenuefilter: revenueFilterRange, legendSort, cumulativeType, showCumulativeRevenueChart, startSyncView, name, curves, revenues, showLoe, getFicBicData: colorByFicBic },

                }, { root: true });
                context.commit('setChartLoading', false);
            } else if (chartType === 'new') {
                const response = await context.dispatch('api/request', {
                    service: 'newDrugs',
                    type: 'exportChartCsv',
                    data: {
                        range: newRange,
                        companies,
                        categories,
                        subcategories,
                        classes,
                        brands,
                        excludeBrands,
                        quarterData,
                        tags,
                        revenues,
                        curves,
                        revenuefilter: revenueFilterRange,
                        legendSort,
                        cumulativeType,
                        showCumulativeRevenueChart,
                        startSyncView,
                        name,
                        revenues,
                        showLoe,
                        getFicBicData: colorByFicBic,
                    },
                }, { root: true });
                context.commit('setChartLoading', false);
            }

        },
        async loadChart(context, id) {
            const chartIsOpened = context.getters.getCharts.findIndex(charts => (charts.id === id && charts.state === 'view'));

            if (chartIsOpened >= 0) {
                context.commit('selectChart', chartIsOpened);
                return;
            }

            const chart = await context.dispatch('api/request', {
                service: 'chart',
                type: 'get',
                data: { id },
            }, { root: true });

            if (chart) {
                context.commit('setChart', chart);
                await context.dispatch('applyFilters', { filters: chart.filters });

                context.commit('setChartInit', { chartName: chart.name, chartState: 'view' });
            }
        },
        async saveChart(context, chart) {

            const modifyChart = {...chart};

            if (modifyChart.filters.breakApart) {
                modifyChart.filters.chartType = modifyChart.filters.parentChartType;
            }

            if (modifyChart.filters.curves === '') {
                delete modifyChart.filters.curves;
            }

            if (modifyChart.filters.quarterData === '') {
                delete modifyChart.filters.quarterData;
            }

            const savedChart = await context.dispatch('api/request', {
                service: 'chart',
                type: 'save',
                data: { chart },
            }, { root: true });

            if (savedChart && savedChart.id) {
                context.dispatch('message/show', {
                    type: 'success',
                    text: 'Chart was successfully saved!',
                }, { root: true });

                context.commit('setChart', savedChart);

                await context.dispatch('applyFilters', { filters: modifyChart.filters, chartName: savedChart.name });
            } else {
                context.dispatch('message/show', {
                    type: 'error',
                    text: 'Chart with this name already exists! Please use another name.',
                }, { root: true });
            }

            return savedChart;
        },
        async deleteChart(context, id) {
            const deletedChart = await context.dispatch('api/request', {
                service: 'chart',
                type: 'delete',
                data: { id },
            }, { root: true });

            if (deletedChart) {
                context.dispatch('message/show', {
                    type: 'success',
                    text: 'Chart was deleted successfully!',
                }, { root: true });
                const chartIndex = context.getters.getCharts.findIndex(chart => {
                    if (typeof chart.id !== 'undefined' &&  chart.id === id) return chart;
                });

                if (chartIndex !== -1) {
                    context.commit('removeChart', chartIndex);
                }
            }
        },
        async renameChart(context, {chart, setName = true}){
            const renamedChart = await context.dispatch('api/request', {
                service: 'chart',
                type: 'rename',
                data: { chart },
            }, { root: true });

            if (!renamedChart) {
                context.dispatch('message/show', {
                    type: 'error',
                    text: 'Chart with this name already exists! Please use another name.',
                }, { root: true });

                return false;
            }

            context.dispatch('message/show', {
                type: 'success',
                text: 'Chart was renamed successfully!',
            }, { root: true });

            if (setName) {
                context.commit('setChartName', renamedChart.name);
            }

            return true;
        },
        async breakApart(context, { parentChartType, rateData, rateName, firstInit, filters, chartName, addNewChart = true }) {

            context.commit('setChartLoading', true);

            const response = await context.dispatch('api/request', {
                service: 'breakApart',
                type: 'getAll',
                data: { rateData, companies: filters.companies,  growthRatesQuarters: filters.growthRatesQuarters , getFicBicData: true },
            }, { root: true });

            context.commit('setChartLoading', false);

            if (response) {

                if(addNewChart) context.commit('addChart');

                const chartFicBicData =  (response.chartFicBicData!==undefined)? response.chartFicBicData:null;

                context.commit('setChartData', response.revenues);
                context.commit('setChartFicBicData', chartFicBicData);
                context.commit('setChartEvents', response.events);
                context.commit('setFilters', Object.assign({}, filters, { chartType: 'revenue', breakApart: true, parentChartType: parentChartType }));

                setTimeout(async () => {

                    if (firstInit) {
                        context.commit('setChartInit', {
                            chartName: (chartName !=='' && typeof chartName !== 'undefined') ? chartName : '', //`Broken apart data for growth rate ${rateName}`
                            chartState: 'view',
                        });
                    } else {
                        await context.dispatch('drawGraph');
                    }

                }, 0);
            }
        },
        async breakApartCumulative(context, {parentChartType, firstInit, itemId, chartName, addNewChart = true}) {

            itemId =parseInt(itemId);
            const chart = context.state.charts[context.state.currentIndex];

            let filters = chart.filters;
            const name = chart.name;
            const filtersData = JSON.parse(JSON.stringify(filters));
            let {chartType, cumulativeType, growthRates, growthRatesQuarters, range, revenueFilterRange, companies, categories, subcategories, classes, brands, excludeBrands, quarterData, tags, revenues, curves, showStopIcon, scaleLogType, legendSort, showCumulativeRevenueChart, startSyncView, showLoe, colorByFicBic} = filtersData;

            if (filters.cumulativeType === 'company') {
                filtersData.companies = companies = [itemId];
            }
            if (filters.cumulativeType === 'class') {
                filtersData.classes = classes = [itemId];
            }

            if (filtersData.cumulativeType === 'category') {

                // if we have subcategories also present filter out non related to the category
                if (subcategories) {

                    const allSubCategories = context.rootState.subcategory.subcategories;

                    // filter from all the subcats, the related to the category
                    const relatedSubCategories = allSubCategories
                        .filter(function (subcategory) {
                            return subcategory.parent_id === itemId;
                        });

                    // compare vs selected
                    let selectedRelatedSubCategories = relatedSubCategories
                        .filter(function (subcategory) {
                            return subcategories.indexOf(subcategory.id) >= 0;
                        });

                    //remove excess data and convert to an int array
                    selectedRelatedSubCategories = selectedRelatedSubCategories.map(a => a.id);

                    // replace subcategories in the filter
                    filtersData.subcategories = subcategories = selectedRelatedSubCategories;
                }

                filtersData.categories = categories = [itemId];
            }

            if (filtersData.cumulativeType === 'sub-category') {
                filtersData.categories = categories = [];
                filtersData.subcategories = subcategories = [itemId];
            }

            filtersData.cumulativeType = cumulativeType = 'none';
            filtersData.revenues = revenues = [];
            filtersData.curves = curves = null;

            context.commit('setChartLoading', true);

            if (filtersData.chartType === 'revenue') {

                const response = await context.dispatch('api/request', {
                    service: 'drugRevenue',
                    type: 'getAll',
                    data: {
                        companies,
                        categories,
                        subcategories,
                        classes,
                        brands,
                        excludeBrands,
                        quarterData,
                        tags,
                        revenuefilter: revenueFilterRange,
                        cumulativeType,
                        showCumulativeRevenueChart: showCumulativeRevenueChart,
                        startSyncView: startSyncView,
                        showLoe,
                        getFicBicData: true,
                    },
                }, {root: true});
                if (response) {
                    context.commit('setChartLoading', false);

                    const chartCumulativeData =  (response.cumulativeRevenueChart!==undefined)? response.cumulativeRevenueChart:null;
                    const chartFicBicData =  (response.chartFicBicData!==undefined)? response.chartFicBicData:null;

                    if (addNewChart) context.commit('addChart');

                    context.commit('setChartData', response.revenues);
                    context.commit('setChartCumulativeData', chartCumulativeData); 
                    context.commit('setChartFicBicData', chartFicBicData);
                    context.commit('setChartEvents', response.events);
                    context.commit('setFilters', Object.assign({}, filtersData, {
                        chartType: 'revenue',
                        breakApart: false,
                        parentChartType: parentChartType,
                        isBreakApart: true,
                    }));

                    setTimeout(async () => {

                        if (firstInit) {
                            context.commit('setChartInit', {
                                chartName: (chartName !== '' && typeof chartName !== 'undefined') ? chartName : '', //`Broken apart data for growth rate ${rateName}`
                                chartState: 'view',
                            });
                        } else {
                            await context.dispatch('drawGraph');
                        }

                    }, 0);

                }

            }

            if (filtersData.chartType === 'new') {
                const newRange = range=== null? 0:range;
                const response = await context.dispatch('api/request', {
                    service: 'newDrugs',
                    type: 'getAll',
                    data: {
                        range: newRange,
                        companies,
                        categories,
                        subcategories,
                        classes,
                        brands,
                        excludeBrands,
                        quarterData,
                        tags,
                        revenues,
                        curves,
                        revenuefilter: revenueFilterRange,
                        cumulativeType,
                        showCumulativeRevenueChart: showCumulativeRevenueChart,
                        startSyncView: startSyncView,
                        showLoe,
                        getFicBicData: true,
                    },
                }, { root: true });

                if (response) {
                    context.commit('setChartLoading', false);

                    const chartData = response.revenues;
                    const chartCumulativeData =  (response.cumulativeRevenueChart!==undefined)? response.cumulativeRevenueChart:null;
                    const chartFicBicData =  (response.chartFicBicData!==undefined)? response.chartFicBicData:null;
                    const chartEvents = response.events;
                    if (addNewChart) context.commit('addChart');

                    context.commit('setChartData', response.revenues);
                    context.commit('setChartCumulativeData', chartCumulativeData);
                    context.commit('setChartFicBicData', chartFicBicData); 
                    context.commit('setChartEvents', response.events);
                    context.commit('setFilters', Object.assign({}, filtersData, {
                        chartType: 'new',
                        breakApart: false,
                        parentChartType: parentChartType,
                        isBreakApart: true,
                    }));

                    setTimeout(async () => {

                        if (firstInit) {
                            context.commit('setChartInit', {
                                chartName: (chartName !== '' && typeof chartName !== 'undefined') ? chartName : '', //`Broken apart data for growth rate ${rateName}`
                                chartState: 'view',
                            });
                        } else {
                            await context.dispatch('drawGraph');
                        }

                    }, 0);

                }
            }
        },
        async redrawGraph(context) {
            const chart = context.state.charts[context.state.currentIndex];

            if (!chart.drawingService) return;

            const chartSvgElement = document.querySelector(`#chart-drawing-${chart.chartId}`);

            if (chartSvgElement && !chartSvgElement.hasChildNodes()) {
                await context.dispatch('drawGraph');
            } else if (chartSvgElement) {
                    // force a refresh of the chart
                setTimeout(() => {
                    if (typeof chart.drawingService !== 'undefined' && chart.drawingService !== null) chart.drawingService.resize();
                }, 0);
            }
        }
    },
};
